<mat-icon class="arrow-button" (click)="menuStateChange()">{{
  isFilterOpen ? "navigate_next" : "navigate_before"
  }}</mat-icon>
<div class="menu-container">
  <div class="buttons-container">
    <a href="https://s4polarin.eu/" class="btn" title="Go To Home"><mat-icon class="mat-18">home</mat-icon></a>
    <a href="https://s4polarin.eu/data-coverage/data-catalog/" class="btn" title="Go To Data Catalog"><mat-icon class="mat-18">view_list</mat-icon></a>
    <button class="btn" type="button" (click)="openInfoDialog()" title="Info"><mat-icon class="mat-18">info</mat-icon></button>
  </div>

  <div class="selection-container">
    <emodnet-menu-selected class="grid-auto-rows" [categories]="categories" [setCustom]="customId"
      (filtersSelected)="filtersChanged.emit(false)"></emodnet-menu-selected>
  </div>
  <div class="filters-container">
    <emodnet-menu-selector [categories]="categories" [map]="mapInstance"
      (activateTimeFilterRequest)="onActivateTimeFilter($event)" (activateCustom)="onActivateCustom($event)"
      (filtersSelected)="filtersChanged.emit(true)"></emodnet-menu-selector>
  </div>
</div>

<dialog class="dialog-style" id="dialog-webgis" closed>
  <h3 class="dialog-title">Information on Data Viewer</h3>
  <p class="text-style">{{text}}</p>
  <button class="button-style" (click)="closeInfoDialog()">X</button>
</dialog>
